import TransportationActivity from './TransportationActivity';
import AccommodationActivity from './AccommodationActivity';
import AttractionActivity from './AttractionActivity';
import TransportationModal from './TransportationModal';
import AccommodationModal from './AccommodationModal';
import AttractionModal from './AttractionModal';

// Function to render the appropriate activity component based on type
// This is the ONLY place where activity HTML/JSX is generated - uses separate components for each type
export function renderActivity(activity, dayId, onEdit, onDelete, onUpdateCompletion, onUpdateDescriptionAlign, collapseCompletedActivities, forceCollapsed, nextActivityInfo, previousActivityInfo) {
  switch(activity.type) {
    case 'transportation':
      return (
        <TransportationActivity 
          activity={activity} 
          dayId={dayId} 
          onEdit={onEdit} 
          onDelete={onDelete}
          onUpdateCompletion={onUpdateCompletion}
          onUpdateDescriptionAlign={onUpdateDescriptionAlign}
          collapseCompletedActivities={collapseCompletedActivities}
          forceCollapsed={forceCollapsed}
          nextActivityInfo={nextActivityInfo}
          previousActivityInfo={previousActivityInfo}
        />
      );
    case 'accommodation':
      return (
        <AccommodationActivity 
          activity={activity} 
          dayId={dayId} 
          onEdit={onEdit} 
          onDelete={onDelete}
          onUpdateCompletion={onUpdateCompletion}
          onUpdateDescriptionAlign={onUpdateDescriptionAlign}
          collapseCompletedActivities={collapseCompletedActivities}
          forceCollapsed={forceCollapsed}
          nextActivityInfo={nextActivityInfo}
          previousActivityInfo={previousActivityInfo}
        />
      );
    default:
      // Use AttractionActivity as the default for any other type
      return (
        <AttractionActivity 
          activity={activity} 
          dayId={dayId} 
          onEdit={onEdit} 
          onDelete={onDelete}
          onUpdateCompletion={onUpdateCompletion}
          onUpdateDescriptionAlign={onUpdateDescriptionAlign}
          collapseCompletedActivities={collapseCompletedActivities}
          forceCollapsed={forceCollapsed}
          nextActivityInfo={nextActivityInfo}
          previousActivityInfo={previousActivityInfo}
        />
      );
  }
}

export { 
  TransportationActivity, 
  AccommodationActivity, 
  AttractionActivity,
  TransportationModal,
  AccommodationModal,
  AttractionModal 
}; 